import { SortOrder } from '../../../redux/context/filters/types'

/**
 * Fiscal year column choices stored per user in this browser. Kept outside persist:root,
 * which is cleared on logout, so the choices survive logging out and back in.
 */
export interface FiscalYearColumnPreferences {
  fiscalYearIdsByCompany: Record<string, number[]>
  groupSortOrder: SortOrder
  monthSortOrder: SortOrder
}

const storageKey = (userId: number) => `fiscalYearColumns:${userId}`

const isSortOrder = (value: unknown): value is SortOrder => value === 'asc' || value === 'desc'

export const saveFiscalYearColumnPreferences = (userId: number, preferences: FiscalYearColumnPreferences) => {
  try {
    localStorage.setItem(storageKey(userId), JSON.stringify(preferences))
  } catch {
    // Storage full or blocked -> preferences just aren't remembered
  }
}

export const loadFiscalYearColumnPreferences = (userId: number): FiscalYearColumnPreferences | undefined => {
  try {
    const raw = localStorage.getItem(storageKey(userId))
    if (!raw) return undefined
    const parsed = JSON.parse(raw)
    return {
      fiscalYearIdsByCompany:
        parsed?.fiscalYearIdsByCompany && typeof parsed.fiscalYearIdsByCompany === 'object'
          ? parsed.fiscalYearIdsByCompany
          : {},
      groupSortOrder: isSortOrder(parsed?.groupSortOrder) ? parsed.groupSortOrder : 'asc',
      monthSortOrder: isSortOrder(parsed?.monthSortOrder) ? parsed.monthSortOrder : 'asc'
    }
  } catch {
    return undefined
  }
}
